
<!-- Produtos (painel compartilhado com a Solicitação) -->
<app-ced-produtos
  [products]="products"
  [somenteLeitura]="somenteLeitura"
  [avisoAlteracao]="cotAvisoAlteracaoProduto"
  (productsChange)="cotOnProductsChange($event)"
  (dirty)="dirty.emit()">
</app-ced-produtos>

<!-- 1 — Fornecedores convidados -->
<div class="section-title">
  <mat-icon>storefront</mat-icon>
  <span>Fornecedores convidados</span>
  <span class="status-badge badge-cinza">{{ cotSuppliers.length }}</span>
  @if (!somenteLeitura) {
    <div class="section-title-actions ms-auto">
      @if (!cotAdding) {
        <button mat-button type="button" class="btn-section" (click)="cotToggleAdding()">
          <mat-icon>add</mat-icon>
          Adicionar fornecedor
        </button>
      } @else {
        <button mat-button type="button" class="btn-section btn-section--cancel" (click)="cotToggleAdding()">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      }
    </div>
  }
</div>

@if (cotAdding) {
  <div class="ced-cot-add">
    <div class="ced-cot-add__head">
      <mat-icon class="material-symbols-outlined">person_add</mat-icon>
      <span>Convidar fornecedor para a cotação</span>
      <span class="ced-section-spacer"></span>
      <button type="button" class="ced-cot-add__close" (click)="cotToggleAdding()" matTooltip="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
    <div class="ced-cot-add__body">
      <app-select-pesquisavel
        [control]="fornecedorControl"
        [apiUrl]="urlFornecedor"
        [disabled]="cotAdicionando"
        [excludeIds]="cotIdsFornecedoresConvidados"
        label="Fornecedor"
        idField="id"
        nameField="descricao"
        subscriptSizing="dynamic"
        (selectionChange)="cotAddSupplier($event)">
      </app-select-pesquisavel>
      <div class="ced-cot-add__hint">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        O fornecedor entra na cotação na hora e já pode ser comparado na matriz. O envio do formulário continua sendo sugerido ao salvar o card.
      </div>
    </div>
  </div>
}

<div class="ced-cot-suppliers">
  @for (s of cotSuppliers; track s.id) {
    <div class="ced-cot-row" [class.ced-cot-row--open]="expandedSupplierId === s.id">
      <div class="ced-cot-row__main">
        <div class="ced-cot-row__info">
          <div class="ced-cot-row__name">
            <span>{{ s.name }}</span>
            @if (s.origem === OrigemCotacaoEnum.Planilha) {
              <span class="ced-cot-via" matTooltip="Resposta importada via planilha">
                <mat-icon class="material-symbols-outlined">table_view</mat-icon>
                via planilha
              </span>
            } @else if (s.origem === OrigemCotacaoEnum.Link) {
              <span class="ced-cot-via" matTooltip="Resposta recebida via link">
                <mat-icon class="material-symbols-outlined">link</mat-icon>
                via link
              </span>
            }
          </div>
          <div class="ced-cot-row__when">{{ s.when }}</div>
        </div>
        <div class="ced-cot-row__badges">
          <span class="status-badge"
            [class.badge-verde]="s.status === 'recebida'"
            [class.badge-amarelo]="s.status !== 'recebida' && s.enviada"
            [class.badge-cinza]="s.status !== 'recebida' && !s.enviada">
            <mat-icon class="material-symbols-outlined">{{ s.status === 'recebida' ? 'check_circle' : (s.enviada ? 'schedule' : 'mail') }}</mat-icon>
            {{ s.status === 'recebida' ? 'Proposta recebida' : (s.enviada ? 'Aguardando resposta' : 'Não enviada') }}
          </span>
          @if (cotDesatualizada[s.id]; as aviso) {
            <span class="status-badge badge-amarelo" [matTooltip]="aviso">
              <mat-icon class="material-symbols-outlined">sync_problem</mat-icon>
              Desatualizada
            </span>
          }
        </div>
        @if (!somenteLeitura) {
          <button type="button" mat-icon-button class="ced-cot-row__remove"
            (click)="cotRemoveSupplier(s)"
            matTooltip="Remover fornecedor da cotação">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
        }
        <button type="button" mat-icon-button class="ced-cot-row__toggle"
          [class.ced-cot-row__toggle--open]="expandedSupplierId === s.id"
          (click)="cotToggleExpand(s.id)"
          [matTooltip]="expandedSupplierId === s.id ? 'Recolher' : 'Expandir'">
          <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
        </button>
      </div>

      @if (expandedSupplierId === s.id) {
        <div class="ced-cot-row__body">
          <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">payments</mat-icon>
            Condição de pagamento para {{ s.name }}
          </div>
          <div class="ced-cot-row__body-text">
            Específica deste fornecedor. Enviada junto com a cotação e replicada no Pedido de Compra.
          </div>
          @if (cotParcelasState[s.id]; as pc) {
            <app-cotacao-parcelas-editor
              [state]="pc"
              [dataBase]="dataBaseParcelas"
              [formasPagamento]="formasPagamento"
              [somenteLeitura]="somenteLeitura"
              (changed)="cotMarcarMeioPagamentoAlterado(s.id)">
            </app-cotacao-parcelas-editor>
          }
          @if (s.observacoes) {
            <div class="ced-cot-obs">
              <div class="ced-cot-obs__label">
                <mat-icon class="material-symbols-outlined">sticky_note_2</mat-icon>
                Observações do fornecedor
              </div>
              <p class="ced-cot-obs__text">{{ s.observacoes }}</p>
            </div>
          }

          <div class="ced-cot-row__actions">
            <span class="ced-cot-row__actions-note">
              {{ !s.enviada ? 'Cotação ainda não enviada para este fornecedor.' : 'Última cotação enviada ' + s.when + '.' }}
              @if (cotDesatualizada[s.id]; as aviso) {
                <span class="ced-cot-row__stale">
                  <mat-icon class="material-symbols-outlined">sync_problem</mat-icon>
                  {{ aviso }}
                </span>
              }
            </span>
            @if (!somenteLeitura) {
            <button mat-stroked-button type="button" class="btn-secondary" (click)="cotCopiarLink(s)"
              [disabled]="cotSendingId === s.id"
              matTooltip="Gerar e copiar o link do portal deste fornecedor (para enviar por outro canal)">
              <mat-icon class="material-symbols-outlined">link</mat-icon>
              Copiar link
            </button>
            <button mat-flat-button type="button" class="btn-primary btn-spinner"
              [class.btn-loading]="cotSendingId === s.id"
              (click)="cotSendSupplier(s)"
              [disabled]="cotSendingId === s.id"
              [attr.aria-label]="cotSendingId === s.id ? 'Enviando cotação' : (!s.enviada ? 'Enviar cotação' : 'Reenviar cotação')"
              [matTooltip]="!s.enviada ? 'Enviar cotação para este fornecedor' : 'Reenviar cotação'">
              <mat-icon class="material-symbols-outlined">{{ !s.enviada ? 'send' : 'forward_to_inbox' }}</mat-icon>
              {{ !s.enviada ? 'Enviar cotação' : 'Reenviar cotação' }}
              @if (cotSendingId === s.id) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- Cotação por planilha (fluxo offline) -->
@if (!somenteLeitura) {
<app-alert-card type="neutral" icon="table_view">
  <div class="ced-cot-alert__title">
    Cotação por planilha
    <span class="ced-cot-alert__tag">fluxo offline</span>
  </div>
  <div class="ced-cot-alert__sub">
    Para fornecedores que preferem responder por outro meio de comunicação. Baixe o modelo, envie ao fornecedor e importe o arquivo preenchido — os preços entram automaticamente na matriz.
  </div>
  <div alertActions class="ced-cot-sheet__cta">
    <button mat-stroked-button type="button" class="btn-secondary" [matMenuTriggerFor]="menuModelo"
      matTooltip="Baixar o modelo com os produtos da cotação — escolha o formato">
      <mat-icon class="material-symbols-outlined">download</mat-icon>
      Baixar modelo
      <mat-icon class="material-symbols-outlined">arrow_drop_down</mat-icon>
    </button>
    @if (cotSheetOpen) {
      <button mat-stroked-button type="button" class="btn-secondary" (click)="cotToggleSheet()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
        Cancelar
      </button>
    } @else {
      <button mat-flat-button type="button" class="btn-primary" (click)="cotToggleSheet()">
        <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
        Importar resposta
      </button>
    }
  </div>
</app-alert-card>

<mat-menu #menuModelo="matMenu">
  <button type="button" mat-menu-item (click)="cotBaixarModelo('xlsx')">
    <mat-icon class="material-symbols-outlined">table_view</mat-icon>
    Planilha (Excel)
  </button>
  <button type="button" mat-menu-item (click)="cotBaixarModelo('pdf')">
    <mat-icon class="material-symbols-outlined">picture_as_pdf</mat-icon>
    PDF
  </button>
  <button type="button" mat-menu-item (click)="cotBaixarModelo('csv')">
    <mat-icon class="material-symbols-outlined">description</mat-icon>
    CSV
  </button>
</mat-menu>
}

@if (cotSheetOpen) {
  <div class="ced-cot-sheet__body">
    <div class="ced-field">
      <mat-form-field appearance="outline" class="ced-form-field" subscriptSizing="dynamic">
        <mat-label>Fornecedor que está respondendo</mat-label>
        <mat-select [(ngModel)]="cotSheetSupplierId">
          @for (s of cotSuppliers; track s.id) {
            <mat-option [value]="s.id">{{ s.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <input #cotSheetInput type="file" accept=".csv,.xlsx,.xlsm" style="display:none" (change)="cotOnSheetFile($event)" />
    <div
      class="ced-cot-drop"
      [class.ced-cot-drop--filled]="cotSheetFileName"
      (click)="cotPickSheet()"
      (dragover)="$event.preventDefault()"
      (drop)="cotOnSheetDrop($event)">
      <span class="ced-cot-drop__ico">
        <mat-icon class="material-symbols-outlined">{{ cotSheetFileName ? 'description' : 'cloud_upload' }}</mat-icon>
      </span>
      <div class="ced-cot-drop__info">
        @if (cotSheetFileName) {
          <div class="ced-cot-drop__name">{{ cotSheetFileName }}</div>
          <div class="ced-cot-drop__hint">pronto para importar</div>
        } @else {
          <div class="ced-cot-drop__name"><strong>Clique para enviar</strong> ou arraste e solte</div>
          <div class="ced-cot-drop__hint">CSV ou Excel (.xlsx/.xlsm) — Máx 5MB por arquivo</div>
        }
      </div>
      @if (cotSheetFileName) {
        <button type="button" class="ced-cot-drop__clear" (click)="$event.stopPropagation(); cotClearSheetFile()" matTooltip="Remover arquivo">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>

    <div class="ced-cot-sheet__actions">
      <span class="ced-cot-sheet__actions-note">
        O sistema lê SKU, preço unitário e prazo. Demais colunas viram observações no card do fornecedor.
      </span>
      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="cotImportando" (click)="cotToggleSheet()">
        Cancelar
      </button>
      <span matTooltip="Selecione o fornecedor e o arquivo preenchido para importar" [matTooltipDisabled]="cotCanImport">
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="cotImportando"
          [disabled]="!cotCanImport || cotImportando" [attr.aria-label]="cotImportando ? 'Importando' : 'Importar'"
          (click)="cotSubmitImport()">
          <mat-icon class="material-symbols-outlined">upload</mat-icon>
          Importar
          @if (cotImportando) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
      </span>
    </div>
  </div>
}

<!-- 2 — Pedido montado -->
<div class="section-title">
  <mat-icon>shopping_cart_checkout</mat-icon>
  <span>{{ cotHasSelection ? 'Pedido montado' : 'Compare propostas e monte o pedido' }}</span>
  @if (cotHasSelection && !somenteLeitura) {
    <div class="section-title-actions ms-auto">
      <button mat-button type="button" class="btn-section" (click)="cotOpenMatrix()">
        <mat-icon>edit</mat-icon>
        Editar na matriz
      </button>
    </div>
  }
</div>

@if (cotHasSelection) {
  <div class="ced-cot-selection">
    <!-- Resumo somente leitura: critério e seleção são decididos na matriz de comparação. -->
    @if (cotUniqueSuppliers.length > 1) {
      <div class="ced-cot-selection__top">
        <span class="ced-cot-split">Split em {{ cotUniqueSuppliers.length }} fornecedores</span>
      </div>
    }

    <div class="ced-cot-table-wrap">
      <table class="ced-cot-table">
        <thead>
          <tr>
            <th>Produto</th>
            <th>Fornecedor</th>
            <th class="ced-cot-table--r">Qtd</th>
            <th class="ced-cot-table--r">Preço unit.</th>
            <th class="ced-cot-table--r">Subtotal</th>
          </tr>
        </thead>
        <tbody>
          @for (it of cotSelection; track it.sku) {
            <tr>
              <td>
                <div class="ced-cot-table__name">{{ it.name }}</div>
                <div class="ced-cot-table__sku ced-mono">{{ it.sku }}</div>
              </td>
              <td>
                <span class="ced-cot-table__vendor">
                  <span class="ced-cot-dot" [style.background]="it.supplierColor"></span>
                  {{ it.supplier }}
                </span>
              </td>
              <td class="ced-cot-table--r ced-cot-table__num">{{ it.qty }}</td>
              <td class="ced-cot-table--r ced-cot-table__num">R$ {{ cotFmt(cotUnitPrice(it)) }}</td>
              <td class="ced-cot-table--r ced-cot-table__num ced-cot-table__subtotal">R$ {{ cotFmt(it.subtotal) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="ced-cot-selection__total">
      <span>Total geral</span>
      <span class="ced-section-spacer"></span>
      <span class="ced-cot-selection__total-val">R$ {{ cotFmt(cotSelectionTotal) }}</span>
    </div>
  </div>
} @else {
  <app-alert-card type="neutral" icon="compare_arrows">
    <div class="ced-cot-alert__title">Compare propostas para montar o pedido</div>
    <div class="ced-cot-alert__sub">
      {{ cotAllReceived ? 'Escolha um fornecedor por produto. Você pode comprar de mais de um.' : 'Você já pode comparar com as propostas recebidas, mas o ideal é aguardar todas.' }}
    </div>
    @if (!somenteLeitura) {
      <div alertActions>
        <button mat-flat-button type="button" class="btn-primary" (click)="cotOpenMatrix()">
          Abrir matriz
          <mat-icon class="material-symbols-outlined">arrow_forward</mat-icon>
        </button>
      </div>
    }
  </app-alert-card>
}

<!-- 3 — Justificativa da escolha -->
<div class="section-title">
  <mat-icon>edit_note</mat-icon>
  <span>Justificativa da escolha</span>
</div>
<div class="ced-cot-just-hint">Registrada no histórico do card e enviada ao aprovador.</div>
<div class="ced-field">
  <mat-form-field appearance="outline" class="ced-form-field">
    <textarea matInput rows="3" [ngModel]="justificativa" [disabled]="somenteLeitura"
      (ngModelChange)="justificativa = $event; justificativaChange.emit($event); dirty.emit()"
      placeholder="Descreva o critério e o motivo da escolha dos fornecedores…"></textarea>
  </mat-form-field>
</div>
